import React, { Component } from 'react';

export class Header extends Component {
  render() {
    return(
      <div className="page-wrapper-row">
          <div className="page-wrapper-top">
              <div className="page-header">
                  <div className="page-header-top">
                      <div className="container">
                          <div className="page-logo">
                              <a href="index.html">
                                  <img src="assets/own/img/logo.png" alt="logo" className="logo-default" style={{ height: 35 + "px" }}></img>
                              </a>
                          </div>
                          <a href="#" className="menu-toggler"></a>
                      </div>
                  </div>
                 <div className="page-header-menu">
                      <div className="container">
                          <div className="hor-menu  ">
                              { this.props.gotInfos && !this.props.error &&
                              <ul className="nav navbar-nav">
                                <li aria-haspopup="true" className="menu-dropdown classic-menu-dropdown active">
                                      <a href="#stats"> Statistiken
                                          <span className="arrow"></span>
                                      </a>
                                  </li>
                                  <li aria-haspopup="true" className="menu-dropdown mega-menu-dropdown  ">
                                      <a href="#tariff"> Tarif Informationen
                                          <span className="arrow"></span>
                                      </a>
                                  </li>
                                  <li aria-haspopup="true" className="menu-dropdown mega-menu-dropdown  ">
                                      <a href="#config"> Werbeeinstellungen
                                          <span className="arrow"></span>
                                      </a>
                                  </li>
                              </ul>
                                                              }
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header.js